import { useContext } from 'react';
import { ThemeSwitchingContext } from '../App';

/**
 * Hook to access theme switching functionality
 *
 * @returns {Object} Theme utilities
 * @returns {string} activeTheme - Current theme ('LIGHT' | 'DARK')
 * @returns {Function} toggleTheme - Function to toggle between themes
 * @returns {boolean} isDark - True if current theme is dark
 * @returns {boolean} isLight - True if current theme is light
 */
export const useTheme = () => {
    const context = useContext(ThemeSwitchingContext);

    if (!context) {
        throw new Error('useTheme must be used within a ThemeSwitchingContext.Provider');
    }

    return {
        activeTheme: context.activeTheme,
        toggleTheme: context.toggleTheme,
        isDark: context.activeTheme === 'DARK',
        isLight: context.activeTheme === 'LIGHT',
    };
};
